import { render, staticRenderFns } from "./RouteFooter.vue?vue&type=template&id=54fa63c2&scoped=true"
import script from "./RouteFooter.vue?vue&type=script&lang=js"
export * from "./RouteFooter.vue?vue&type=script&lang=js"
import style0 from "./RouteFooter.vue?vue&type=style&index=0&id=54fa63c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fa63c2",
  null
  
)

export default component.exports